module.exports = __webpack_public_path__ + "static/media/19_B.c5d85bb0.png";